// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"29152521","456":"1ca22acc","656":"7027ccea","756":"6a975818","968":"297fc303"}[chunkId] + ".chunk.js";
};